import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Badge } from "@/components/Badge";
import { Icon } from "@/components/Icon";

import { IIconBadge } from "../types";

export const BadgeWithTitle: React.FC<IIconBadge> = ({ iconType, text }) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  return (
    <div
      className={css({
        display: "flex",
        alignItems: "center",
        [bp.ONLY_MOBILE]: {
          margin: "10px 0",
        },
      })}
    >
      <Badge
        size={40}
        customStyle={{
          backgroundColor: colors.WHITE,
          boxShadow: `4px 8px 8px 0 ${colors.CETACEAN_BLUE}`,
        }}
      >
        <Icon iconType={iconType} />
      </Badge>

      <p
        className={css({
          fontSize: 18,
          marginLeft: 20,
          color: colors.DARK_GREY,
        })}
      >
        {text}
      </p>
    </div>
  );
};
